/**
 * PUBLICAR UM QUADRINHO VAZIO — `T8.13`, a terceira metade do achado.
 *
 * Ele, na letra: *"A tela também aceita publicar um quadrinho sem nenhum conteúdo (o teste tinha só
 * quadros em branco, '1 KB')."*
 *
 * ── MEDIDO EM 27/09, E NÃO HAVIA VERIFICAÇÃO NENHUMA ────────────────────────────────────────
 *
 * A tela de publicar tinha uma recusa por **tamanho** (`recusaPorTamanho`, do `T6.6`) e nenhuma por
 * **vazio**. Então uma folha com seis molduras em branco ia para a biblioteca aberta, e aparecia lá com
 * o nome da criança e o nome da escola.
 *
 * ── POR QUE MOLDURA NÃO É CONTEÚDO, E IMAGEM É ──────────────────────────────────────────────
 *
 * A grade de quadros **nasce com a página** — seis retângulos são o que o produto desenha antes de
 * alguém fazer qualquer coisa. Publicar isso não é publicar um quadrinho; é publicar o formulário em
 * branco.
 *
 * O que conta como conteúdo é o que a criança colocou:
 *
 *   · **desenho** — personagem, cenário ou figura
 *   · **fala ou narração** com texto dentro
 *
 * Um balão **sem texto** também não conta: ele é moldura de outro tipo. E é por isso que a conta olha o
 * texto e não só a existência do elemento.
 *
 * ── O QUE ESTA REGRA NÃO FAZ ────────────────────────────────────────────────────────────────
 *
 * Não julga se o quadrinho é bom, nem se está "completo". Uma página com um desenho e nenhuma fala é um
 * quadrinho legítimo — muita história de criança é assim, e recusá-la seria pior que o defeito. A régua
 * é **um** elemento de conteúdo em **alguma** página, e ela é a mais baixa que ainda distingue "fez" de
 * "não fez".
 */
import { Pagina } from "../api/documento.types";

/** Quantos elementos de conteúdo o quadrinho inteiro tem — desenho, ou fala com texto. */
export function quantosConteudos(paginas: Pagina[]): number {
  let total = 0;
  for (const pagina of paginas ?? []) {
    for (const camada of pagina.camadas ?? []) {
      for (const el of camada.elementos ?? []) {
        if (el.tipo === "imagem") total++;
        else if (el.tipo === "balao" || el.tipo === "texto") {
          // O texto é o que faz um balão ser conteúdo. Balão vazio é moldura de outro tipo.
          const texto = (el as { texto?: unknown }).texto;
          if (typeof texto === "string" && texto.trim()) total++;
        }
      }
    }
  }
  return total;
}

/**
 * O motivo de recusar, ou `null` quando dá para publicar.
 *
 * Devolve a FRASE e não um booleano porque a tela mostra o motivo ao lado do botão desativado — é a
 * mesma forma da recusa por tamanho, e é o que o `T8.30` pede em geral: *"desativar a opção, em vez de
 * deixar tentar e falhar"*.
 */
export function motivoDeRecusaPorVazio(paginas: Pagina[]): string | null {
  if (quantosConteudos(paginas) > 0) return null;
  return (
    "Este quadrinho ainda está em branco — só tem as molduras dos quadros. Coloque um desenho ou " +
    "escreva uma fala antes de publicar, para quem abrir encontrar a sua história."
  );
}
